<form [formGroup]="storeFormGroup">
  <ng-template #headerTemplate>
    <div class="tw-text-xl">1. Vælg abonnement</div>
  </ng-template>
  <sb-plans
    [plans]="plans$ | async"
    [selectedPlanId]="storeFormGroup.controls.subscription_plan_id.value"
    (selectPlan)="onSelectPlan($event)"
    [loading]="loading$ | async"
    [headerTemplate]="headerTemplate"
  >
    <div class="tw-flex tw-flex-col tw-mt-10 tw-gap-2">
      <div class="tw-text-xl tw-mb-2">2. Angiv forretningsoplysninger</div>
      <div class="tw-flex tw-flex-col tw-gap-4 tw-w-1/2 tw-mx-auto">
        <div>
          <p-floatlabel variant="on">
            <input
              id="business_name"
              pInputText
              [formControl]="storeFormGroup.controls.name"
              class="tw-w-full {{
                storeFormGroup.controls.name.invalid && storeFormGroup.controls.name.touched
                  ? 'ng-invalid ng-dirty'
                  : ''
              }}"
            />
            <label for="business_name"> Forretningsnavn </label>
          </p-floatlabel>
          <sb-form-error [control]="storeFormGroup.controls.name" [errorMessage]="'Skal udfyldes'" />
        </div>

        <div>
          <p-floatlabel variant="on">
            <sb-luxon-datepicker
              [readonlyInput]="true"
              [formControl]="storeFormGroup.controls.auto_bookkeeping_after"
              [showIcon]="true"
              dateFormat="dd. MM yy"
              appendTo="body"
              styleClass="tw-w-full"
              panelStyleClass="!tw-min-w-0"
              class="{{
                storeFormGroup.controls.auto_bookkeeping_after.invalid &&
                storeFormGroup.controls.auto_bookkeeping_after.touched
                  ? 'ng-invalid ng-dirty'
                  : ''
              }}"
            />
            <label for="bookkeeping_date"> Vælg startdato for bogføring </label>
          </p-floatlabel>
          <sb-form-error [control]="storeFormGroup.controls.auto_bookkeeping_after" [errorMessage]="'Skal udfyldes'" />
        </div>
        @if (showPromotionCodeField()) {
          <div class="tw-col-span-4">
            <p-floatlabel variant="on">
              <input
                class="tw-w-full"
                type="text"
                id="promotion_code"
                pInputText
                [formControl]="storeFormGroup.controls.promotion_code"
              />
              <label for="promotion_code"> Rabat kode </label>
            </p-floatlabel>
          </div>
        }
        <div class="tw-flex tw-items-center tw-gap-1">
          <label for="is_terms_approved">Godkend</label>
          <p-checkbox inputId="is_terms_approved" binary formControlName="is_terms_approved" />

          <a sbLink href="https://storebuddy.dk/betingelser" target="_blank">handelsbetingelser</a>
        </div>
        <p-button
          fluid
          size="small"
          [disabled]="!storeFormGroup.valid || storeFormGroup.pristine"
          (click)="onCreateStore()"
          [loading]="loading$ | async"
        >
          Start 10 dages prøveperiode
        </p-button>
        @if ((alert$ | async)?.message !== null) {
          <sb-alert
            variant="info"
            [message]="(alert$ | async)?.message"
            iconName="exclamation-circle"
            [link]="{ url: (alert$ | async).href, text: (alert$ | async).hrefLabel, type: 'href' }"
          />
        }
      </div>
    </div>
  </sb-plans>
</form>
